import React from "react"

import { CardActions, Grid, Skeleton } from "@mui/material"
import { MenuItem, Tag, Tooltip, Typography } from "@synapse-analytics/synapse-ui"
import moment from "moment"

import styles from "./SelectionCard.module.scss"

interface SelectionCardProps {
  item: {
    title: string
    createdAt: string
    state?: string
    version?: string
    isWorkflowActive?: boolean
  }
  tagVariant?: "green" | "red" | "yellow" | "blue" | "orange"
  onClick?: () => void
  state?: "default" | "selected" | "pending"
  ref?: (node?: Element | null) => void
}

/**
 * @param {object} item card item meta data
 * @param {"positive" | "negative" | "warning" | "default"} tagVariant (optional) variant for the tag to be displayed, defaults to "default"
 * @param {object} onClick (optional) on click action
 * @param {"default" | "selected" | "pending"} state (optional) card state, defaults to "default"
 * @return {React.ReactElement}
 */
export function SelectionCard(props: Readonly<SelectionCardProps>): React.ReactElement {
  const { item, onClick, tagVariant = "blue", state = "default", ref } = props

  return (
    <MenuItem
      onClick={() => {
        onClick?.()
      }}
      isSelected={state === "selected"}
      ref={ref}
      key={item.createdAt}
    >
      <Grid container item xs={12} display={"flex"} gap={1}>
        <Grid item maxWidth={150} mb={1}>
          <Tooltip title={item.title}>
            {/* TODO:: fix this from SUI */}
            <Typography variant="a" noWrap style={{ maxWidth: "150px" }}>
              {item.title}
            </Typography>
          </Tooltip>
        </Grid>

        {item.version && (
          <Grid item xs>
            <Typography variant="a" color={item.isWorkflowActive ? "positive" : "base"} variantColor={2} align="right">
              v{item.version}
            </Typography>
          </Grid>
        )}
      </Grid>

      <Grid container item xs={12} display={"flex"} gap={1} alignItems={"center"}>
        <Grid item xs>
          <Typography variant="label-regular" variantColor={2}>
            {moment(new Date(item.createdAt)).format("MMM DD h:mma")}
          </Typography>
        </Grid>
        {item.state && (
          <Tag size="small" color={tagVariant}>
            {item.state}
          </Tag>
        )}
      </Grid>
    </MenuItem>
  )
}

/**
 * Loader component for the Selection card
 * @returns {React.ReactElement}
 */
export function SelectionLoaderCard(): React.ReactElement {
  return (
    <CardActions className={`${styles.card} ${styles.noPointer}`}>
      <Grid container item xs={12} gap={0.5}>
        <Grid item xs={12}>
          <Skeleton animation="wave" width="50%" />
        </Grid>

        <Grid container item xs={12} gap={1} wrap="nowrap">
          <Skeleton animation="wave" width="75%" />
        </Grid>
      </Grid>
    </CardActions>
  )
}
